import React, { useState, Component, useEffect } from 'react'
import cn from 'classnames'
import { Modal, Input, Table, Popconfirm, Form, Select, InputNumber, Button, Tabs } from 'antd'

import { sagaModal } from 'redux-saga-modal'
import * as apis from '@/apis'

const isTenantMode = process.env.APP_MODE === 'tenant';
const isManagerMode = process.env.APP_MODE === 'manager';

function reminderDialog(props) {
  const {
    modal: {
      name,
    },
    isOpen,
    show,
    update,
    destroy,
    click,
    submit,
    hide,
    showModal,
    updateModal,
    submitModal,
    clickModal,
    hideModal,
    destroyModal,
    ...ownProps
  } = props
  const { getFieldDecorator, validateFields, getFieldValue, setFieldsValue } = props.form;

  const [reasonList, setReasonList] = useState([]);
  const [activeKey, setActiveKey] = useState('0');

  const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
  };

  const initData = () => {
    apis.getAllReasons({ type: 'cuidan' }).then(res => {
      setReasonList(res.reason || []);
    })
  }

  const handleSubmit = () => {
    validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }
      submit(values);
    });
  }
  useEffect(() => {
    initData()
  }, [])
  return (
    <Modal
      title={ownProps.title}
      destroyOnClose
      width={500}
      visible={isOpen}
      onOk={handleSubmit}
      onCancel={hide}
      mask={false}
      wrapClassName="order-detail-modal-wrap"
      maskStyle={{ position: 'absolute' }}
      getContainer={() => document.getElementById('order-detail-wrap') || window}
    >
      <Form {...formItemLayout} >
        {/* <Tabs
          defaultActiveKey={activeKey}
          size="small"
          onChange={(val) => {
            setActiveKey(val)
            resetFields()
          }}>
          {
            reasonList.map((item, index) => {
              return <Tabs.TabPane tab={item.name} key={String(index)} ></Tabs.TabPane>
            })
          }
        </Tabs> */}

        <Form.Item label="选择原因" width={120}>
          {getFieldDecorator('selsct_reason', {
            rules: [
              {
                required: true,
                message: '请选择原因',
              },
            ],
          })(
            <Select placeholder="请选择原因" onChange={(val) => {
              setFieldsValue({ content: val })
            }}>
              {
                reasonList[activeKey]?.list.map(reason => {
                  if (reason.groupName && reason.list) {
                    return (
                      <Select.OptGroup key={reason.groupName} label={reason.groupName}>
                        {
                          reason.list.map(reason => (
                            <Select.Option key={reason} value={reason}>{reason}</Select.Option>
                          ))
                        }
                      </Select.OptGroup>
                    )
                  }

                  return <Select.Option key={reason} value={reason}>{reason}</Select.Option>
                })
              }
            </Select>
          )}
        </Form.Item>

        <Form.Item
          label="催单内容"
        >
          {getFieldDecorator('content', {
            rules: [
              { required: true, message: `请输入内容`, }
            ],
          })(
            <Input.TextArea rows={4} placeholder={`请输入内容`} />
          )}
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default sagaModal({
  name: 'ORDER_REMINDER_DIALOG',
})(Form.create()(reminderDialog))
